// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import OperatePeopleSvg from '@rsuite/icon-font/lib/people/OperatePeople';
var OperatePeople = createSvgIcon({
  as: OperatePeopleSvg,
  ariaLabel: 'operate people',
  category: 'people',
  displayName: 'OperatePeople'
});
export default OperatePeople;